<template>
    <div>
        <div class="view offers-view" v-if="actives">
            <div class="offers-filters">
                <StoreSelect
                    @storeSelected="storeSelected"
                    />
                <DateRangeFilter
                    @selectedRange="selectDateRange"
                    />
            </div>
            
            <div class="content-all">
                <div class="header">
                    <h5 class="section-title">Todos los contenidos</h5>
                    <div class="buttons">
                        <router-link :to="{ name: 'content_manager'}" class="button white sm umami--click--gestionar-contenidos">
                            <i class="icon ico-sale"></i>
                            <p>Gestionar contenidos</p>
                        </router-link>
                        <router-link :to="{ name: 'new_content'}" class="button primary sm umami--click--nuevo-contenido">
                            <i class="icon ico-plus"></i>
                            <p>Nuevo Contenido</p>
                    </router-link>
                    </div>    
                </div>
                <div class="reach-graph">
                    <div class="ranking-reach">
                        <ReachCard class="reach-card"
                            title="Alcance"
                            subtitle="Valorización"
                            subtitle2="Interacciones"
                            :valueReach="interactionNumber"
                            :totalRevenue="totalRevenue"
                            :loader="revenueLoaded"
                            tip="Se muestra el revenue estimado, calculado en base a las interacciones con el contenido y a un CPC estimado para la industria. Además, se presenta el número total de interacciones asociadas a los contenidos activos del portal cautivo."
                            titleEmpty=""
                            captionEmpty="No contamos con suficientes datos para mostrar información de valor. Tan pronto podamos, lo mostraremos"
                            />
                        <RankingCard
                            title="Ranking de Contenidos"
                            :data="offerRangkingData"
                            :loader="rankingLoaded"
                            tip="Se muestra el ranking de interacciones con los contenidos, de mayor a menor."
                            titleEmpty=""
                            captionEmpty="No contamos con suficientes datos para mostrar información de valor. Tan pronto podamos, lo mostraremos"
                            />
                    </div>
                    <BarGraphCard
                        title="Total Interacciones"
                        sub=""
                        height="85%"
                        :loader="clicksLoaded"
                        :data="clicksBarChart"
                        :periodItems="period"
                        class="interactions"
                        tip="Gráfico que muestra en columnas apiladas las interacciones por cada contenido en función del tiempo."
                        titleEmpty="Este gráfico no está disponible actualmente"
                        captionEmpty="No contamos con suficientes datos para mostrar información de valor. Tan pronto podamos, lo mostraremos"
                        />
                </div>
            </div>
            <div class="content-slider" v-if="currentOffer.name">
                <div class="header">
                    <h5 class="section-title">Contenido "{{currentOffer.name}}"</h5>
                    <div class="slider-controller">
                        <a class="prev button white" v-on:click="chooseBack">
                            <i class="icon ico-chevron-left"></i>
                        </a>
                        <p> {{offerSlide+1}} de  {{ offers.length }}</p>
                        <a class="next button white" v-on:click="chooseNext">
                            <i class="icon ico-chevron-right"></i>
                        </a>
                    </div>
                </div>
            </div>
            <div class="single-content" v-if="currentOffer.name">
                <div class="preview-performance">
                    <PreviewCard class="preview-card"
                    :loader="currentOffer.name ? true : false"
                    :offers="currentOffer"
                    :firstCategory="category_1"
                    :secondCategory="category_2"
                    :thirdCategory="category_3"
                    :fourCategory="category_4"
                    />
                    <PerformanceCard class="performance-card"
                    :actualRevenue="actualRevenue"
                    prevRevenue="973.009.142"
                    venueName="Valparaiso"
                    venueInteractions="980"
                    :engagement="totalSessions"
                    :daysCount="daysCount"
                    :fromDate="currentOffer.init_date"
                    :toDate="currentOffer.end_date"
                    :created="currentOffer.init_date"
                    :storeOfferClicks="storeOfferClicks"
                    :loader="storeClicksLoaded"
                    :totalClicks="offerClicksCount"
                    :storesRanking="storesRanking"
                    tip="Revenue: Calculado en base a las interacciones con el contenido y a u un CPC estimado para la industria.
Interacciones por sucursal: Muestra las 3 sedes con mayores interacciones con el contenido.
Engagement: Cantidad de interacciones sobre las sesiones que se inician en el portal cautivo.
Vigencia: Cantidad de días de vigencia del contenido."
                    titleEmpty="Este gráfico no está disponible actualmente"
                    captionEmpty="No contamos con suficientes datos para mostrar información de valor. Tan pronto podamos, lo mostraremos"
                    />
                </div>
                <div class="charts">
                    <BarGraphCard class="chart-interactions"
                    title="Total Interacciones"
                        sub=""
                        height="200px"
                        :responsive=true
                        :loader="storeClicksLoaded"
                        :data="storeClicksBarChart"
                        :periodItems="storePeriod"
                        tip="Gráfico que muestra las interacciones con el contenido seleccionado en función del tiempo."
                        titleEmpty="Este gráfico no está disponible actualmente"
                        captionEmpty="No contamos con suficientes datos para mostrar información de valor. Tan pronto podamos, lo mostraremos"
                        />
                    <LineGraphCard 
                    class="chart-engagement" 
                    title="Engagement" 
                    height="200px"
                    :responsive="true"
                    :loader="true"
                    :periodItems="[]"
                    :data="[]"
                    tip="Gráfico que muestra las interacciones sobre las visualizaciones del contenido, en función del tiempo."
                    titleEmpty="Este gráfico no está disponible actualmente"
                    captionEmpty="No contamos con suficientes datos para mostrar información de valor. Tan pronto podamos, lo mostraremos"
                    />
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import axios from 'axios'
import moment from 'moment'

import _ from 'lodash'

// import DeviceNotAllowed from "@/components/DeviceNotAllowed"
import BarGraphCard from "@/components/cards/BarGraphCard"
import RankingCard from "@/components/cards/RankingCard"
import ReachCard from "@/components/cards/ReachCard"
import PerformanceCard from "@/components/cards/PerformanceCard"
import PreviewCard from "@/components/cards/PreviewCard"
import LineGraphCard from "@/components/cards/LineGraphCard"

import StoreSelect from "@/components/StoreSelect"
import DateRangeFilter from "@/components/DateRangeFilter"

import { mapActions, mapGetters } from 'vuex'

export default {
    name: 'Content',
    components: {
        DateRangeFilter,
        StoreSelect,
        ReachCard,
        PerformanceCard,
        PreviewCard,
        RankingCard,
        BarGraphCard,
        LineGraphCard,
        // DeviceNotAllowed
    },
    data: function(){
        return {
            category_1: process.env.VUE_APP_CATEGORY_1,
            category_2: process.env.VUE_APP_CATEGORY_2,
            category_3: process.env.VUE_APP_CATEGORY_3,
            category_4: process.env.VUE_APP_CATEGORY_4,
            search_text: '',
            search_category: '',
            store_id: '999999',
            list: false,
            actives: true,
            clicksLoaded: false,
            clicksBarChart: [],
            period: [],
            offerRangkingData: [],
            rankingLoaded: false,
            totalClicks: 0,
            initRange: moment().subtract(7,'d').format('YYYY-MM-DD'),
            today: moment().format('YYYY-MM-DD'),
            yesterday: moment().subtract(1, 'd').format('YYYY-MM-DD'),
            interactionNumber: 0,
            offerSlide: 0,
            offerTitle: "",
            offerDescription: "",
            offerButton: "",
            offerId: 0,
            initDate: "",
            endDate: "",
            storePeriod: [],
            storeClicksBarChart: [],
            storeClicksLoaded: false,
            storeTotalClicks: 0,
            storeOfferClicks: [],
            totalRevenue: 0,
            revenueLoaded: false,
            imageUrl: '',
            actualRevenue: 0,
            sessions : [],
            totalSessions: 0,
            offerClicksCount: 0,
            storesRanking: [],
            currentOffer : {},
            rangeValue: 0
        }
    },
    created: function(){
        this.$store.dispatch("auth/setActive", "content");
        this.offerRequest("999999")
            .then(() => {
                this.showOffersAnalytics()
                this.offersRanking();
                this.getOfferRevenue();
                this.getSessions();
                this.currentOffer = this.offers[this.offerSlide] ? this.offers[this.offerSlide] : {'name': null, 'description': null, 'button_text': null, 'init_date': null, 'end_date': null, 'images': null}
            }, err => {
                console.log(err)
            })

        this.setFilter("");
        this.setCategory(0);
    },
    methods: {
        getSessions: function(){
            let headers = {
                'Authorization': 'ZGFuaWVsQGZyZWRlc0BlbHVuOm51YmU1NDMyMTBuMHVzM3N3MW5kMHJ6'
            }
            axios.get(process.env.VUE_APP_ANALYTICS_HOST+"/api/sessions/?init_date="+this.initRange+"&end_date="+this.yesterday+"&store_id="+this.store_id, {
            headers: headers
            })
            .then((res) => {
                this.sessions = res.data
                this.totalSessions = 0
                _.each(res.data, (value) => {
                    this.totalSessions = this.totalSessions + value["not_customer"] + value["customer"]
                })
                
            })
            .catch(() => {
                this.sessions = []
                this.totalSessions = 0
            })
            
        },
        checkValue: function(value,arr){
            var status = false;
            
            for(var i=0; i<arr.length; i++){
                var name = arr[i];
                if(name == value){
                status = true;
                break;
                }
            }

            return status;
        },
        chooseBack: function(){
            
            if(this.offerSlide>0){
                this.offerSlide = this.offerSlide-1
                this.currentOffer = this.offers[this.offerSlide]
                this.initDate = this.currentOffer.init_date
                this.endDate = this.currentOffer.end_date
                this.storeClicksLoaded = false
                this.showOffersAnalyticsStore("999999")
                this.getDetailOfferRevenue()
                this.getOfferStoreRanking()
                
            }
        },
        chooseNext: function(){
            if(this.offerSlide+1<this.offers.length){
                this.offerSlide = this.offerSlide+1
                this.currentOffer = this.offers[this.offerSlide]
                this.initDate = this.currentOffer.init_date
                this.endDate = this.currentOffer.end_date
                this.storeClicksLoaded = false
                this.showOffersAnalyticsStore("999999")
                this.getDetailOfferRevenue()
                this.getOfferStoreRanking()
            }
        },
        filter_text: function(){
            this.setFilter(this.search_text);
        },
        // OFFER REVENUE
        getOfferRevenue: function(){
            this.revenueLoaded = false
            let headers = {
                'Authorization': 'ZGFuaWVsQGZyZWRlc0BlbHVuOm51YmU1NDMyMTBuMHVzM3N3MW5kMHJ6'
            }
            if (this.rangeValue === '4'){
                this.yesterday = this.initRange
            }
            else{
                this.yesterday = moment().subtract(1, 'd').format('YYYY-MM-DD')
            }
            axios.get(process.env.VUE_APP_ANALYTICS_HOST+"/api/offers/?init_date="+this.initRange+"&end_date="+this.yesterday+"&store_id="+this.store_id+"&offer_id=999999", {
            headers: headers
            })
            .then((res) => {
                this.revenueLoaded = true
                this.totalRevenue = 0
                _.each(res.data, (value) => {
                    this.totalRevenue = this.totalRevenue + Math.floor(value["revenue"])
                })
            })
        },
        getOfferStoreRanking: function(){
            let headers = {
                'Authorization': 'ZGFuaWVsQGZyZWRlc0BlbHVuOm51YmU1NDMyMTBuMHVzM3N3MW5kMHJ6'
            }
            axios.get(process.env.VUE_APP_ANALYTICS_HOST+"/api/offers/stores/?init_date="+this.initRange+"&end_date="+this.yesterday+"&store_id="+this.store_id+"&offer_id=999999", {
            headers: headers
            })
            .then((res) => {
                this.storesRanking = res.data
            })
            .catch((err)=> {
                console.log(err)
            })
        },
        getDetailOfferRevenue: function(){
            let headers = {
                'Authorization': 'ZGFuaWVsQGZyZWRlc0BlbHVuOm51YmU1NDMyMTBuMHVzM3N3MW5kMHJ6'
            }
            axios.get(process.env.VUE_APP_ANALYTICS_HOST+"/api/offers/?init_date="+this.initRange+"&end_date="+this.yesterday+"&store_id="+this.store_id+"&offer_id="+this.currentOffer.id, {
            headers: headers
            })
            .then((res) => {
                this.actualRevenue = 0
                this.offerClicksCount = 0
                _.each(res.data, (value) => {
                    this.actualRevenue += value["revenue"] ? value["revenue"] : 0
                    this.offerClicksCount = this.offerClicksCount + value["clicks"]
                })
                var offer_revenue = this.actualRevenue.toString().split(".")[0]
                this.actualRevenue = String(offer_revenue).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')
            })
        },
        async getAllOfferNames(){
            try {
                let url = `${process.env.VUE_APP_CORE_HOST}/api/offer/?format=json`;
                const response = await axios.get(url, { 
                    headers: { 
                        Authorization: "Bearer " + this.$store.state.auth.loggedIn.access, 
                    }, 
                });
                return response.data.map(offer => ({id: offer.id, name: offer.name}));

            } catch (error) {
                console.error(error); 
                return [];
            }
        },
        showOffersAnalytics: async function(){
            let headers = {
                'Authorization': 'ZGFuaWVsQGZyZWRlc0BlbHVuOm51YmU1NDMyMTBuMHVzM3N3MW5kMHJ6'
            }
            if (this.rangeValue === '4'){
                this.yesterday = this.initRange
            }
            else{
                this.yesterday = moment().subtract(1, 'd').format('YYYY-MM-DD')
            }
            const offerNames = await this.getAllOfferNames()
            
            let url = process.env.VUE_APP_ANALYTICS_HOST+"/api/offers/content/?init_date="+this.initRange+"&end_date="+this.yesterday+"&store_id="+this.store_id+"&offer_id=999999"
            axios.get(url, {
            headers: headers
            })
            .then((res) => {
                let sumClicks = 0; 
                let periodRange = moment(this.yesterday).diff(moment(this.initRange), 'days') + 1
                let period = []
                let offerIds = []   
                let clicksChartData = []

                // Se genera arreglo con todos los días u horas dentro del rango seleccionado 
                if (this.rangeValue === '4'){
                    for (let index = 0; index < 24; index++) { 
                        const hour = index < 10 ? `0${index}` : `${index}`;
                        period.push(hour);
                    } 
                }else{
                    for (let index = 0; index < periodRange; index++) {
                        if (index > 0) {
                            period.push(moment(this.initRange).add(index, 'days').format('DD-MM-YYYY'))
                } else { 
                            period.push(moment(this.initRange).format('DD-MM-YYYY'))
                        }
                    } 
                } 
                // Se genera el arreglo con todas las ofertas 
                _.each(res.data, (value) => {
                    // let content = this.getOffer(value.offer_id)[0]
                    let content = offerNames.filter(offer => offer.id == value.offer_id)[0]
                    if (content && offerIds.filter(offer => offer == value.offer_id).length == 0) {
                        offerIds.push(value.offer_id)
                        let click = {
                            'name': content.name,
                            'offer_id':value.offer_id,
                            'data': []
                        }

                        clicksChartData.push(click)
                    }
                })

                _.each(period, (date) => {
                    let dateEvents = res.data.filter(event => event.period == date)

                    _.each(clicksChartData, (offerEvent, index) => {
                        let clickEvents = dateEvents.filter(event => event.offer_id == offerEvent.offer_id)
                        if (clickEvents.length > 0) {
                            // if (clickEvents.length > 1) {
                            clicksChartData[index].data.push(clickEvents.reduce((a, b) => a + b.clicks, 0))
                            sumClicks += clickEvents.reduce((a, b) => a + b.clicks, 0)
                            // } else {
                            //     clicksChartData[index].data.push(clickEvents[0].clicks)
                            //     sumClicks += clickEvents[0].clicks
                            // }
                        } else {
                            clicksChartData[index].data.push(0)
                        }
                    })
                })
                this.period = period
                this.clicksBarChart = clicksChartData
                this.clicksLoaded = true
                this.totalClicks = sumClicks
            })
            .catch((err) => {
                console.log(err)
            })
        },
        showOffersAnalyticsStore: async function(storeId){
            this.storeOfferClicks = []

            const offerNames = await this.getAllOfferNames()

            let headers = {
                'Authorization': 'ZGFuaWVsQGZyZWRlc0BlbHVuOm51YmU1NDMyMTBuMHVzM3N3MW5kMHJ6'
            }

            let url = process.env.VUE_APP_ANALYTICS_HOST+"/api/offers/content/?init_date="+this.initRange+"&end_date="+this.yesterday+"&offer_id="+this.offers[this.offerSlide].id+"&store_id="+this.store_id
            
            axios.get(url, {
            headers: headers
            })
            .then((res) => {
                let periodRange = moment(this.yesterday).diff(moment(this.initRange), 'days') + 1
                let period = []
                let offerIds = []
                let clicksChartData = []
                let offerStoreClicks = []

                // Se genera arreglo con todos los días dentro del rango seleccionado

                if (this.rangeValue === '4'){
                    for (let index = 0; index < 24; index++) {
                        const hour = index < 10 ? `0${index}` : `${index}`;
                        period.push(hour);
                    }
                }else{
                    for (let index = 0; index < periodRange; index++) {
                        if (index > 0) {
                            period.push(moment(this.initRange).add(index, 'days').format('DD-MM-YYYY'))
                        } else {
                            period.push(moment(this.initRange).format('DD-MM-YYYY'))
                        }
                    }
                }

                // Se genera el arreglo con todas las ofertas
                _.each(res.data, (value) => {
                    // let content = this.getOffer(value.offer_id)[0]
                    let content = offerNames.filter(offer => offer.id == value.offer_id)[0]
                    if (content && offerIds.filter(offer => offer == value.offer_id).length == 0) {
                        offerIds.push(value.offer_id)

                        let click = {
                            'name': content.name,
                            'offer_id':value.offer_id,
                            'data': []
                        }

                        clicksChartData.push(click)
                    }
                })

                _.each(period, (date) => {
                    let dateEvents = res.data.filter(event => event.period == date)

                    _.each(clicksChartData, (offerEvent, index) => {
                        let clickEvents = dateEvents.filter(event => event.offer_id == offerEvent.offer_id)
                        if (clickEvents.length > 0) {
                            clicksChartData[index].data.push(clickEvents.reduce((a, b) => a + b.clicks, 0))
                        } else {
                            clicksChartData[index].data.push(0)
                        }
                    })
                })

                // Revisar código y replantear funcionamiento

                _.each(res.data, (valuedata, index) => {
                    let content = this.getOffer(valuedata.offer_id)[0]
                    if (content) {  
                        let storeSum = 0
                        let storeName = ""
                        let found = false
                        _.each(res.data[index].data, (storeData) => {
                            storeSum = storeSum + storeData
                        })
                        _.each(this.stores, (store) => {
                            if(store.node_mac===valuedata.node_mac){
                                storeName = store.name
                                _.each(offerStoreClicks, (totalClicks) => {
                                    if(totalClicks.name===store.name){
                                        found = true
                                    }
                                })
                            }
                        })

                        if(!found){
                            let storeTotalClick = {'name': storeName, 'clicks': storeSum}
                            offerStoreClicks.push(storeTotalClick)
                        }
                    }
                })

                this.storeOfferClicks = offerStoreClicks
                this.storePeriod = period
                this.storeClicksBarChart = clicksChartData
                this.storeClicksLoaded = true
                
            })
            .catch(() => {
                this.storeOfferClicks=[]
                
            })
        },
        offersRanking: async function(){
            this.rankingLoaded = false
            if (this.rangeValue === '4'){
                this.yesterday = this.initRange
            }
            else{
                this.yesterday = moment().subtract(1, 'd').format('YYYY-MM-DD')
            }
            let headers = {
                'Authorization': 'ZGFuaWVsQGZyZWRlc0BlbHVuOm51YmU1NDMyMTBuMHVzM3N3MW5kMHJ6'
            }
            let count = 0 
            const offerNames = await this.getAllOfferNames()
            axios.get(process.env.VUE_APP_ANALYTICS_HOST+"/api/offers/ranking/?init_date="+this.initRange+"&end_date="+this.yesterday+"&store_id="+this.store_id, {
                headers: headers
            })
            .then((res) => {
                // let zum = 0
                // _.each(res.data, (value)=>{
                //     zum += value.clicks
                // })
                let ranking = []
                this.interactionNumber = 0
                // if (zum !== 0){
                    _.each(res.data, (value) => {
                        // let content = this.getOffer(value.name)[0]
                        let content = offerNames.filter(offer => offer.id == value.name)[0]
                        if (content) {
                            var click_format = String(value.clicks).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')
                            if(count <=10){
                                ranking.push({'name': content.name, 'clicks': click_format})
                                this.interactionNumber = this.interactionNumber + value.clicks
                                count++
                            }
                        }
                    })
                // }

                if (ranking.length===0) {
					const offers = this.offers
					offers.forEach((offer, index) => {
						if (index <= 10)
						ranking.push({ 'name': offer.name, 'clicks': '0' })
					})
				}
                // if (ranking.length==0) {
				// // axios.get("https://st-portal.notros.io/api/offers", {
				// // })
				// 	// .then((res => {
				// const res=[
                //     {"name": "Oferta 1"},
				// 	{"name": "Oferta 2"},
				// 	{"name": "Oferta 3"},
				// 	{"name": "Oferta 4"},
				// 	{"name": "Oferta 5"}
				// ]
                // this.interactionNumber = 0
				// res.forEach(element => {
				// 	ranking.push({ 'name': element.name, 'clicks': '0' })
                //     })
                // } else {
                //     console.log('ERRRRRRRRORRRR')
                //     this.offerRangkingData = ranking
                // }
                this.offerRangkingData = ranking
                this.rankingLoaded = true
                
                this.getDetailOfferRevenue()
                this.getOfferStoreRanking()
                // this.showOffersAnalyticsStore("this.offers[this.offerSlide].id")
                // TODO: MEJORAR COMPORTAMIENTO
                this.showOffersAnalyticsStore("999999")
                this.getOfferRevenue(this.offers[this.offerSlide].id)

            })
            .catch((err) => {
                console.log(err)
                
            })
        },
        filter_category: function(val){
            this.setCategory(val);
        },
        storeSelected: function(value){
            this.clicksLoaded = false
            this.store_id = value
            this.offerRequest(value)
            .then(() => {
                this.showOffersAnalytics();
                this.offersRanking();
                this.getOfferRevenue();
                this.getSessions()

                this.offerSlide = 0
                this.currentOffer = this.offers[this.offerSlide] ? this.offers[this.offerSlide] : {'name': null, 'description': null, 'button_text': null, 'init_date': null, 'end_date': null, 'images': null}
                this.storeClicksLoaded = false

                this.getDetailOfferRevenue()
                this.getOfferStoreRanking()
                this.showOffersAnalyticsStore(this.offers[this.offerSlide].id)
            }, () => {

            })
            this.setFilter("");
            this.setCategory(0);
        },
        selectDateRange: function(value){
            this.rangeValue = value[3]
            this.clicksLoaded = false;
            this.initRange = value[0]
            this.showOffersAnalytics()
            this.showOffersAnalyticsStore(this.storeId)
            this.offersRanking();
            this.getOfferRevenue();
            this.getSessions();

        },
        controlStrings: function(data) {
            data = data.replace(/á/gi,"a");
            data = data.replace(/é/gi,"e");
            data = data.replace(/í/gi,"i");
            data = data.replace(/ó/gi,"o");
            data = data.replace(/ú/gi,"u");
            data = data.replace(/ñ/gi,"n");
            return data.toLowerCase()
        },
        ...mapActions({
            'offerRequest': 'offers/offerRequest',
            'setCategory': 'offers/selectCategory',
            'setFilter': 'stores/setFilter'
        })
    },
    computed: {
        imageHost: function() {
            return process.env.VUE_APP_CORE_HOST
        },  
        offers: function() {
            var offers = this.getOffers
            offers = offers.filter(offer=>offer.is_active==true)
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.currentOffer = offers[this.offerSlide] ? offers[this.offerSlide] : {'name': null, 'description': null, 'button_text': null, 'init_date': null, 'end_date': null, 'images': null}
            return offers
        },
        daysCount: function(){
            var date1 = moment(this.currentOffer.init_date); 
            if (this.currentOffer.end_date) {
                var date2 = moment(this.currentOffer.end_date); 
                
                let date_diff = date2.diff(date1, 'd')

                if (date_diff > 0) {
                    console.log(date_diff)
                    return date_diff
                } else if (date_diff < 0) {
                    return 0
                }
                return 1
            }
            return 0
        },
        stores: function() {
            var stores = this.getallStores
            return stores
        },
        allOffers(){
            var offers = this.getOffers
            if (this.actives){
                offers = offers.filter(offer=>offer.is_active==this.actives)
            } else {
                offers = offers.filter(offer=>offer.is_active==this.actives)
            }
            if(this.getFilter != ""){
                offers = offers.filter(offer =>
                    this.controlStrings(offer.title).includes(this.controlStrings(this.getFilter)) || this.controlStrings(offer.description).includes(this.controlStrings(this.getFilter))
                );
            }
            if (this.getCategory != 0) {
                offers = offers.filter(offer=>offer.category.some(cat => cat.id == this.getCategory))
            }
            return offers.sort(function(a,b){
                return b.id - a.id
            });
        },
        display: function() {
            if(window.innerWidth < 768){
                return false
            }
            return true
        },
        ...mapGetters({
            'getOffers': 'offers/allOffers',
            'getOffer': 'offers/getOffer',
            'getCategory': 'offers/getSelectedCategory',
            'getStore': 'stores/getSelectedStore',
            'getFilter': 'stores/getFilter',
            'getallStores': 'stores/allStores'
        })
    }
}
</script>

<style lang="sass">
.offers-view
    margin-top: $md
    @include mobile
        grid-template-columns: 8px repeat(2, minmax(0, 1fr)) 8px
    @include mobile-landscape
        grid-template-columns: 8px repeat(2, minmax(0, 1fr)) 8px
    .offers-filters
        display: flex
        grid-column-start: 2
        grid-column-end: span 4
        @include mobile
            grid-column: 2/4
            flex-direction: column
        @include mobile-landscape
            grid-column: 2/4
            flex-direction: row
        .box
            &:first-child
                margin-left: 0px
            @include tablet-portrait
                width: 50%
            @include mobile-landscape
                width: 50%
        .multiselect
            box-sizing: border-box
            
.content-all
    grid-column-start: 2
    grid-column-end: 6
    display: flex
    flex-direction: column
    @include mobile 
        grid-column: 2/4
    @include mobile-landscape
        grid-column: 2/4
    .header 
        margin: $md 0 $xs 0  
        display: flex 
        align-items: center
        justify-content: center
        height: 32px
        .section-title
            flex-grow: 2
        .buttons
            display: flex
            flex-grow: 1
            justify-content: flex-end
            @include mobile
                display: none
            @include mobile-landscape
                display: none
            a
                margin-left: 8px
            
.reach-graph
    align-items: stretch
    flex-direction: row
    display: flex
    height: 488px
    @include mobile-landscape
        flex-direction: column
        height: auto
    .ranking-reach
        display: flex
        flex-direction: column
        align-content: stretch
        width: 30%
        @include mobile
            width: 100%
            flex-direction: column
        @include mobile-landscape
            width: 100%
            flex-direction: row
        @include tablet-portrait
            width: 30%
        .EmptyStateChart .border  
            @include tablet-portrait    
                margin: 8px 
                padding: 8px
        .ranking
            margin-top: $xs
            flex-grow: 7
            box-sizing: border-box
            margin-bottom: 0px
            grid-template-columns: 8px 1fr 1fr 8px
            grid-template-rows: 64px 1fr
            @include mobile-landscape
                margin-left: $xs
                margin-top: 0
                height: auto
            .card-title
                grid-column: 2/4
                margin-top: $xs
            div
                grid-column: 2/4
            .tooltip
                grid-column: 2/5
            .tutorial
                grid-column: 2/5
        .reach-card
            border-radius: 4px
            background: $white
            flex-grow: 1

    .interactions
        flex-grow: 2
        margin-left: $xs
        height: 100%
        @include mobile
            display: none
        @include mobile-landscape
            display: none
            margin-left: 0
            margin-top: $xs
        @include tablet-landscape
            width: 70%
        @include tablet-portrait
            width: 70%

.content-slider
    grid-column-start: 2
    grid-column-end: 6
    display: grid
    @include mobile 
        grid-column: 2/4
    @include mobile-landscape
        grid-column: 2/4
    .header
        margin: $md 0 $xs 0  
        display: flex 
        align-items: center
        justify-content: center
        height: 32px
        @include mobile
            flex-direction: column
            height: auto
    .slider-controller
        font-family: $title-font
        color: $white
        display: flex
        align-items: center
        justify-content: flex-end
        flex-grow: 1
        height: 24px
        @include mobile
            margin-top: $sm
            height: auto
        a 
            color: $white
            font-size: 24px
            height: 32px
            width: 32px
            cursor: pointer
            display: flex
            font-size: 20px
        .prev.button
            border-radius: 8px 0px 0px 8px
            justify-content: center
            .icon
                display: flex
                align-self: center
        .next.button
            border-radius: 0px 8px 8px 0px
            justify-content: center
            .icon
                display: flex
                align-self: center
        p
            font-size: 14px
            font-weight: 100
            font-family: $title-font
            width: 100px
            text-align: center
            align-content: center
            box-sizing: border-box
            background: rgba(255,255,255,0.2)
            padding: 8px
            height: 32px
        

.single-content
    display: flex
    grid-column-start: 2
    grid-column-end: 6
    flex-direction: row
    @include mobile
        grid-column: 2/4
        flex-direction: column
    @include mobile-landscape
        grid-column: 2/4
    .preview-performance
        display: flex
        flex-direction: row
        @include mobile
            width: 100%
        @include mobile-landscape
            flex-direction: column
        @include tablet-portrait
            flex-direction: column
        .preview-card
            width: 280px
            @include mobile
                display: none
            @include mobile-landscape
                display: none
            @include tablet-portrait
                height: 450px
                margint-bottom: 8px
        .performance-card
            margin-left: $xs
            width: 280px
            @include mobile
                width: 100%
                margin-left: 0
            @include mobile-landscape
                margin-left: 0
                height: 100%
            @include tablet-portrait
                margin-left: 0
                margin-top : 8px
    .charts
        display: flex
        flex-direction: column
        flex-grow: 1
        margin-left: $xs
        @include mobile
            margin-top: $xs
            margin-left: 0
        .chart-interactions
            display: grid
            min-height: 276px
            @include tablet-portrait
                height: 50%
        .chart-engagement
            margin-top: $xs
            display: grid
            min-height: 276px
            @include tablet-portrait
                height: 50%

</style>